function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:#242424;}.st1{fill:#353535;}.st2{fill:#FFE11C;}.st3{fill:#FFFFFF;}");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 1920,
  height: 1080
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 680,
  className: "st1",
  width: 1920,
  height: 400
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M823.6,928.9c-43.6,0-79-35.4-79-79V567.8c0-48.8-39.7-88.6-88.6-88.6h-6.8c0,2.8,0,6.2,0,9.6h6.8c43.6,0,79,35.4,79,79v282.1c0,48.8,39.7,88.6,88.6,88.6H1920v-9.6H823.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M364.3,479.3h-20.1c-48.8,0-88.6,39.7-88.6,88.6v282.1c0,43.6-35.4,79-79,79H0v9.6h176.7c48.8,0,88.6-39.7,88.6-88.6V567.8c0-43.6,35.4-79,79-79h20.1C364.3,486,364.3,482.6,364.3,479.3z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M616.9,440.4c-4.3,0-8.2,0.7-11.8,2.1l0-55.3h0c-0.5-16.4-13.9-29.5-30.4-29.5h-11.3L507,414.3l-56.3-56.6h-11.3c-16.5,0-29.9,13.1-30.4,29.5h0v55.5c-3.7-1.4-7.8-2.2-12.3-2.2c-19.3,0-32.3,14.8-32.3,32.3c0,9.1,0,22.7,0,22.7c0,17.8,13.1,32.3,32.3,32.3c4.5,0,8.6-0.8,12.3-2.2v120.4h0.8v203.6c0,24.7,18.1,44.7,44.7,44.7c26.6,0,44.7-20.4,44.7-44.7c0-11.5,0-114.2,0-203.6h16.3v203.6c0,24.7,18.1,44.7,44.7,44.7c26.6,0,44.7-20.4,44.7-44.7c0-11.5,0-114.2,0-203.6h0.2l0-120.1c3.6,1.3,7.6,2,11.9,2c19.3,0,32.3-14.8,32.3-32.3c0-9.1,0-22.7,0-22.7C649.2,454.8,636.2,440.4,616.9,440.4z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M533.9,468.6h-12c-2.1,0-3.8,1.7-3.8,3.8v2.7c0,2.1,1.7,3.8,3.8,3.8h12V468.6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M533.9,489.1h-12c-2.1,0-3.8,1.7-3.8,3.8v2.7c0,2.1,1.7,3.8,3.8,3.8h12V489.1z"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 536.8,
  y: 460.7,
  className: "st2",
  width: 5.8,
  height: 46.8
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M479.5,499.5h12c2.1,0,3.8-1.7,3.8-3.8V493c0-2.1-1.7-3.8-3.8-3.8h-12V499.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M479.5,479h12c2.1,0,3.8-1.7,3.8-3.8v-2.7c0-2.1-1.7-3.8-3.8-3.8h-12V479z"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 470.9,
  y: 460.7,
  className: "st2",
  width: 5.8,
  height: 46.8
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M545.7,507.4h21.6c9.5,0,17.3-7.7,17.3-17.3V478c0-9.5-7.7-17.3-17.3-17.3h-21.6V507.4z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M467.7,460.7h-21.6c-9.5,0-17.3,7.7-17.3,17.3v12.2c0,9.5,7.7,17.3,17.3,17.3h21.6V460.7z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M507,172.5c-46.1,0-83.4,37.3-83.4,83.4c0,46.1,37.3,83.4,83.4,83.4c46.1,0,83.4-37.3,83.4-83.4C590.4,209.8,553.1,172.5,507,172.5z M473.7,267.9c-5.4,0-9.8-4.4-9.8-9.8c0-1.4,0.3-2.8,0.9-4h17.8c0.6,1.2,0.9,2.6,0.9,4C483.5,263.5,479.1,267.9,473.7,267.9z M537.1,267.9c-5.4,0-9.8-4.4-9.8-9.8c0-1.4,0.3-2.8,0.9-4H546c0.6,1.2,0.9,2.6,0.9,4C546.9,263.5,542.5,267.9,537.1,267.9z"
});

function SvgClientServerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1920px",
    height: "1080px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientServerError);
export default __webpack_public_path__ + "static/media/client-server-error.8a50c266.svg";
export { ForwardRef as ReactComponent };